import { render, staticRenderFns } from "./IQAnswerViewAll.vue?vue&type=template&id=a696d4f0&scoped=true"
import script from "./IQAnswerViewAll.vue?vue&type=script&setup=true&lang=js"
export * from "./IQAnswerViewAll.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQAnswerViewAll.vue?vue&type=style&index=0&id=a696d4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a696d4f0",
  null
  
)

export default component.exports